









































































import { Component, Emit, Prop, Watch } from "vue-property-decorator"
import Vue from "vue"
import * as rules from "@/rules"

@Component
export default class FactorGroupScoringDefinition extends Vue {
    @Prop()
    factorGroup!: any

    @Prop({ default: false, type: Boolean })
    small: boolean

    @Prop({ default: false, type: Boolean })
    xSmall: boolean

    @Prop({default: false, type: Boolean})
    customize: boolean

    @Prop({default: '', type: String})
    viewpointScoring: string

    @Prop({ default: null, type: Boolean })
    viewpointHideScores: boolean

    @Prop({ default: false, type: Boolean })
    groupScoreToggle: boolean

    @Prop()
    tooltip!: string

    private dialog = false

    private form: any = {}

    private rules = {
        required: rules.REQUIRED,
    }

    private summaryScoringFunction = [
        {
            text: "Weighted Sum",
            value: "WEIGHTED_SUM",
        },
        {
            text: "Min",
            value: "MIN",
        },
        {
            text: "Max",
            value: "MAX",
        },
    ]

    $refs!: {
        form: HTMLFormElement
    }

    mounted() {
        if (this.factorGroup) {
            this.form.summaryScoringFunction = (this.viewpointScoring) ? this.viewpointScoring : this.factorGroup.summaryScoringFunction;
            if (this.groupScoreToggle) {
                this.form.hideScores = (this.viewpointHideScores !== null) ? this.viewpointHideScores : this.factorGroup.hideScores;
            }
        } else {
            this.form.summaryScoringFunction = null;
            if (this.groupScoreToggle) {
                this.form.hideScores = null;
            }
        }
    }

    @Watch("factorGroup")
    private onFactorGroupChange() {
        if (this.factorGroup) {
            this.form.summaryScoringFunction = (this.viewpointScoring) ? this.viewpointScoring : this.factorGroup.summaryScoringFunction
            if (this.groupScoreToggle) {
                this.form.hideScores = (this.viewpointHideScores !== null) ? this.viewpointHideScores : this.factorGroup.hideScores;
            }
        } else {
            this.form.summaryScoringFunction = null
            if (this.groupScoreToggle) {
                this.form.hideScores = null;
            }
        }
    }

    @Watch("viewpointScoring")
    private onViewpointScoringChange() {
        if (this.factorGroup) {
            this.form.summaryScoringFunction = (this.viewpointScoring) ? this.viewpointScoring : this.factorGroup.summaryScoringFunction
        } else {
            this.form.summaryScoringFunction = null
        }
    }

    @Watch("viewpointHideScores")
    private onViewpointHideScores() {
        if (this.groupScoreToggle) {
            if (this.factorGroup) {
                this.form.hideScores = (this.viewpointHideScores !== null) ? this.viewpointHideScores : this.factorGroup.hideScores;
            }
            else {
                this.form.hideScores = false;
            }
        }
    }

    @Emit()
    submit() {
        if (!this.$refs.form.validate()) {
            return
        }
        this.dialog = false
        return this.form
    }

    @Emit("cancel")
    cancel() {
        this.dialog = false
    }
}
